// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.responsive-flex {
  display: flex;
  justify-content: space-evenly;
}
.responsive-flex button {
  margin: 3px 3px;
}

@media (max-width: 768px) {
  .responsive-flex {
    display: block;
  }
  .responsive-flex button {
    max-width: 82vw;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRpYWxvZy5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQUE7RUFDQSw2QkFBQTtBQUNGO0FBQUU7RUFDRSxlQUFBO0FBRUo7O0FBRUE7RUFDRTtJQUNFLGNBQUE7RUFDRjtFQUNFO0lBQ0UsZUFBQTtJQUNBLGdCQUFBO0lBQ0EsdUJBQUE7RUFDSjtBQUNGIiwiZmlsZSI6ImRpYWxvZy5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5yZXNwb25zaXZlLWZsZXgge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWV2ZW5seTtcbiAgYnV0dG9uIHtcbiAgICBtYXJnaW46IDNweCAzcHg7XG4gIH1cbn1cblxuQG1lZGlhIChtYXgtd2lkdGg6IDc2OHB4KSB7XG4gIC5yZXNwb25zaXZlLWZsZXgge1xuICAgIGRpc3BsYXk6IGJsb2NrO1xuXG4gICAgYnV0dG9uIHtcbiAgICAgIG1heC13aWR0aDogODJ2dztcbiAgICAgIG92ZXJmbG93OiBoaWRkZW47XG4gICAgICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgICB9XG4gIH1cbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/shared/ui/dialog/dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,6BAAA;AACF;AAAE;EACE,eAAA;AAEJ;;AAEA;EACE;IACE,cAAA;EACF;EACE;IACE,eAAA;IACA,gBAAA;IACA,uBAAA;EACJ;AACF;AACA,oxBAAoxB","sourcesContent":[".responsive-flex {\n  display: flex;\n  justify-content: space-evenly;\n  button {\n    margin: 3px 3px;\n  }\n}\n\n@media (max-width: 768px) {\n  .responsive-flex {\n    display: block;\n\n    button {\n      max-width: 82vw;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
